import { APP_INITIALIZER, NgModule } from '@angular/core';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';

function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: environment.oauth,
      initOptions: {
        pkceMethod: 'S256',
        silentCheckSsoFallback: false,
        checkLoginIframe: false,
        onLoad: 'check-sso',
        scope: 'gpf-owners-portal-api',
        redirectUri: (() => {
          // Preserve full URL path and query parameters when redirecting from m-3.com to gerances.ch
          const currentUrl = new URL(window.location.href);
          const canonicalUrl = new URL(environment.redirectUri);
          canonicalUrl.pathname = currentUrl.pathname;
          canonicalUrl.search = currentUrl.search;
          canonicalUrl.hash = currentUrl.hash;
          return canonicalUrl.toString();
        })(),
      },
      bearerExcludedUrls: ['maps.googleapis.com'],
    });
}

@NgModule({
  imports: [KeycloakAngularModule],
  providers: [
    AuthGuard,
    AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
  ],
})
export class AuthModule {}
